import EshopConfiguration from "../services/EshopConfiguration";
import { parseJSONScript } from "../../../js/common/json";
import eshopCategoryMenuService from "./EshopCategoryMenuService";
import eshopDiscountMenuService from "./EshopDiscountMenuService";
import loginFormService from "./LoginFormService";
import fixedEshopHeaderService from "./FixedEshopHeaderService";
import breadcrumbScrollInitService from "./BreadcrumbScrollInitService";
import eshopHeaderSearchInputService from "./EshopHeaderSearchInputService";
import { HeaderConfiguration } from "./common";

export default new class EshopHeaderService {
    public init(eshopConfiguration: EshopConfiguration): void {
        const headerConfiguration = parseJSONScript<HeaderConfiguration>("#js-header-configuration");

        eshopCategoryMenuService.init(headerConfiguration);
        eshopDiscountMenuService.init(headerConfiguration);
        eshopHeaderSearchInputService.init(eshopConfiguration.searchBoxQuery, eshopConfiguration.luigisboxTrackerId, eshopConfiguration.luigisboxHostname);
        loginFormService.init();
        fixedEshopHeaderService.init();
        breadcrumbScrollInitService.init();
    }

    public toggleCategoriesMenu(): void {
        eshopCategoryMenuService.toggleMenuVisibility();
    }
}();
